"use strict";

new Vue({
  mixins: [main],
  data: function data() {
    return {
      items: [],
      storeType: undefined,
      storeTypeAll: '1',
      store: this.getUrlVal('store'),
      area: this.getUrlVal('area'),
      category: this.getUrlVal('category'),
      tag: this.getUrlVal('tag'),
      number: 20,
      paged: this.getUrlVal('paged') !== undefined && Number(this.getUrlVal('paged')) >= 1 ? Number(this.getUrlVal('paged')) : 1,
      maxPages: undefined,
      loading: true,
      searchStoreItems: [],
      searchStore: this.getUrlVal('store')
    };
  },
  computed: {
    searchStoreText: function searchStoreText() {
      var _this = this;

      var text = 'すべて';
      this.searchStoreItems.some(function (store) {
        if (store.value === _this.searchStore) {
          text = store.text;
          return true;
        }
      });
      return text;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.store === 'all') {
      this.storeType = '4';
      this.storeTypeAll = undefined;
      this.store = undefined;
    }

    this.storeType = this.getUrlVal('type') !== undefined ? this.getUrlVal('type') : this.storeType;
    axios.get(apiUrl + '/api/get_news', {
      params: {
        store_type: this.storeType,
        store_type_all: this.storeTypeAll,
        store: this.store,
        area: isNaN(this.area) ? undefined : this.area,
        category: this.category,
        tag: this.tag,
        r18: this.isApp() ? '0' : '1',
        number: this.number,
        paged: this.paged
      }
    }).then(function (response) {
      _this2.items = response.data.items.map(function (item) {
        return {
          title: item.title,
          img: item.thumbnail ? olineImgUrl + '/' + item.thumbnail : templateDirectoryUri + '/img/no_image_news_' + item.category.id + '.jpg',
          category: item.category,
          date: item.date,
          storeType: item.store_type,
          store: item.store.map(function (store) {
            return store.name;
          }),
          url: '/news/' + item.id + '/',
          r18Flag: item.r18_flag
        };
      });
      _this2.maxPages = response.data.max_pages;
      _this2.loading = false;
    });
    axios.get(apiUrl + '/api/get_store').then(function (response) {
      var items = response.data.items.filter(function (store) {
        return exStores.indexOf(store.name) === -1;
      }).sort(function (storeA, storeB) {
        return storeA.area - storeB.area;
      }).map(function (store) {
        return {
          text: store.name.replace(/^らしんばん/, ''),
          value: String(store.id)
        };
      });
      items.unshift({
        text: 'すべて',
        value: ''
      }, {
        text: '全店',
        value: 'all'
      });
      _this2.searchStoreItems = items;
    });
  }
});